/**
 * Represents consumption types defined by the Platform
 */
export enum ConsumptionType {
  /**
   * Represents VOD content
   */
  VOD = 'vod',

  /**
   * Represents Live content
   */
  LIVE = 'live',
}
